/**
 * Approved German copy for the "Creators & Influencers" page (/bloggers).
 * Loaded after the machine-generated audit dictionaries (alphabetical glob
 * order), so these values win for every key listed here.
 */
const dict: Record<string, string> = {
  // Hero
  "FOR CREATORS & INFLUENCERS": "FÜR CREATOR & INFLUENCER",
  "Earn from brand campaigns that fit your audience":
    "Verdienen Sie mit Markenkampagnen, die zu Ihrer Zielgruppe passen",
  "See campaign requirements and payment terms before you start, track results and earnings in one place, and get support from a dedicated Creator Manager.":
    "Sehen Sie Kampagnenanforderungen und Vergütungsbedingungen, bevor Sie starten, verfolgen Sie Ergebnisse und Einnahmen zentral an einem Ort und erhalten Sie Unterstützung von einem persönlichen Creator Manager.",
  "Websites and Blogs": "Websites und Blogs",
  "Other Content Channels": "Weitere Content-Kanäle",
  "View offers": "Angebote ansehen",
  "Join as a Creator": "Als Creator starten",
  "Quick start in just a few minutes": "Schnellstart in nur wenigen Minuten",

  // Hero illustration
  REC: "REC",
  Campaign: "Kampagne",
  Earnings: "Einnahmen",
  "Creator Manager support": "Creator Manager Support",
  "Scout support": "Scout-Support",


  // Three steps
  "Start in three clear steps": "In drei klaren Schritten starten",
  "Step 1": "Schritt 1",
  "Step 2": "Schritt 2",
  "Step 3": "Schritt 3",
  "Create your profile": "Profil erstellen",
  "Add your content channels and tell us about your audience, topics, and content formats.":
    "Fügen Sie Ihre Content-Kanäle hinzu und erzählen Sie uns mehr über Ihre Zielgruppe, Themen und Content-Formate.",
  "Choose campaigns for your audience": "Kampagnen für Ihre Zielgruppe auswählen",
  "Discover relevant products, brands, and campaigns. Get the materials and tools needed to create content.":
    "Entdecken Sie relevante Produkte, Marken und Kampagnen. Sie erhalten die Materialien und Tools, die Sie für die Content-Erstellung benötigen.",
  "Create content and earn": "Content erstellen und verdienen",
  "Publish your content, track results in your account, and receive rewards according to campaign terms.":
    "Veröffentlichen Sie Ihren Content, verfolgen Sie die Ergebnisse in Ihrem Konto und erhalten Sie Ihre Vergütung gemäß den Kampagnenbedingungen.",

  // Categories and formats (both tab states)
  "Categories and formats without limits": "Kategorien und Formate ohne Einschränkungen",
  "Categories and formats": "Kategorien und Formate",
  "Content formats": "Content-Formate",
  "Product categories": "Produktkategorien",
  "Create content your way": "Erstellen Sie Content auf Ihre Art",
  "Use posts, articles, long-form videos, short-form videos, stories, reviews, product selections, and native integrations.":
    "Nutzen Sie Posts, Artikel, Longform-Videos, Kurzvideos, Stories, Reviews, Produktauswahlen und native Integrationen.",
  "Choose the format that works best for your platform, audience, and campaign requirements.":
    "Wählen Sie das Format, das am besten zu Ihrer Plattform, Ihrer Zielgruppe und den Kampagnenanforderungen passt.",
  "Find products that fit your audience": "Finden Sie Produkte, die zu Ihrer Zielgruppe passen",
  "Explore campaigns across electronics, fashion, beauty, home, family and kids, sports, food, and other categories.":
    "Entdecken Sie Kampagnen aus den Kategorien Elektronik, Fashion, Beauty, Wohnen, Familie & Kinder, Sport, Lebensmittel und weiteren Bereichen.",
  "Recommend products you understand and can present naturally in your content.":
    "Empfehlen Sie Produkte, die Sie kennen und authentisch in Ihrem Content präsentieren können.",

  // Monetization channels
  "Create and earn across the channels you already use":
    "Erstellen Sie Content und verdienen Sie über die Kanäle, die Sie bereits nutzen",
  "Promote products through Reels, Stories, posts, and native recommendations.":
    "Bewerben Sie Produkte über Reels, Stories, Posts und native Empfehlungen.",
  "Create reviews, Shorts, product selections, and useful video content.":
    "Erstellen Sie Reviews, Shorts, Produktauswahlen und hilfreichen Video-Content.",
  "Create short videos, product recommendations, and trend-based content.":
    "Erstellen Sie Kurzvideos, Produktempfehlungen und trendbasierten Content.",
  "Monetize communities, pages, groups, and audience recommendations.":
    "Monetarisieren Sie Communities, Seiten, Gruppen und Empfehlungen für Ihre Zielgruppe.",
  "Share product selections, promo codes, and marketplace recommendations with your audience.":
    "Teilen Sie Produktauswahlen, Promo-Codes und Marketplace-Empfehlungen mit Ihrer Zielgruppe.",
  "Messaging platforms": "Messaging-Plattformen",
  "Recommend products through channels, communities, chats, and direct messages.":
    "Empfehlen Sie Produkte über Kanäle, Communities, Chats und Direktnachrichten.",
  "Websites and blogs": "Websites und Blogs",
  "Earn from articles, reviews, product rankings, and evergreen content.":
    "Verdienen Sie mit Artikeln, Reviews, Produktrankings und Evergreen-Content.",
  "Coupon and cashback platforms": "Coupon- und Cashback-Plattformen",
  "Earn from promo codes, discounts, product selections, and deal pages.":
    "Verdienen Sie mit Promo-Codes, Rabatten, Produktauswahlen und Deal-Seiten.",
  "Price comparison websites": "Preisvergleichsportale",
  "Monetize product cards, prices, ratings, and comparison tables.":
    "Monetarisieren Sie Produktkarten, Preise, Bewertungen und Vergleichstabellen.",
  "Paid traffic and media buying": "Paid Traffic und Media Buying",
  "Drive external traffic through paid placements and performance campaigns.":
    "Generieren Sie externen Traffic über bezahlte Platzierungen und Performance-Kampagnen.",
  "Browser Extensions": "Browser-Erweiterungen",
  "Connect users with relevant products, discounts, and offers while they shop online.":
    "Verbinden Sie Nutzer während des Online-Shoppings mit relevanten Produkten, Rabatten und Angeboten.",
  "Other traffic sources": "Weitere Traffic-Quellen",
  "Use any format that helps your audience discover and buy relevant products.":
    "Nutzen Sie jedes Format, das Ihrer Zielgruppe hilft, relevante Produkte zu entdecken und zu kaufen.",

  // Tools and support
  "You create content and recommend products": "Sie erstellen Content und empfehlen Produkte",
  "Catuik provides the tools and support": "Catuik stellt Ihnen die Tools und den Support bereit",
  "Products for different audiences": "Produkte für unterschiedliche Zielgruppen",
  "Explore products and campaigns across a wide range of categories and choose offers that match your content and audience.":
    "Entdecken Sie Produkte und Kampagnen aus einer Vielzahl von Kategorien und wählen Sie Angebote aus, die zu Ihrem Content und Ihrer Zielgruppe passen.",
  "Ready-made creatives and campaign materials": "Fertige Werbemittel und Kampagnenmaterialien",
  "Use prepared campaign materials, product cards, post texts, tracked links, and creatives to launch faster and reduce manual work.":
    "Nutzen Sie vorbereitete Kampagnenmaterialien, Produktkarten, Post-Texte, Tracking-Links und Werbemittel, um schneller zu starten und den manuellen Aufwand zu reduzieren.",
  "Start earning without direct brand negotiations":
    "Verdienen Sie ohne direkte Verhandlungen mit Marken",
  "Choose products, publish content, and start earning from confirmed actions without long negotiations with advertisers.":
    "Wählen Sie Produkte aus, veröffentlichen Sie Content und verdienen Sie mit bestätigten Aktionen, ohne langwierige Verhandlungen mit Werbetreibenden.",
  "Results and earnings in one place": "Ergebnisse und Einnahmen an einem Ort",
  "Track clicks, actions, campaign results, confirmation status, and available earnings in your account.":
    "Verfolgen Sie Klicks, Aktionen, Kampagnenergebnisse, Bestätigungsstatus und verfügbare Einnahmen in Ihrem Konto.",

  // Final CTA
  "Ready to turn your content into income?": "Bereit, mit Ihrem Content Geld zu verdienen?",
  "Join thousands of bloggers and creators who already earn with Catuik.":
    "Schließen Sie sich Tausenden Bloggern und Creatorn an, die bereits mit Catuik verdienen.",
  "Relevant products and campaign opportunities": "Relevante Produkte und Kampagnenmöglichkeiten",
  "Tracked links and ready-made materials": "Tracking-Links und fertige Werbemittel",
  "Flexible formats for any content channel": "Flexible Formate für jeden Content-Kanal",
  "Clear analytics, payouts, and support": "Klare Analytics-Daten, Auszahlungen und Support",
  "Start earning": "Jetzt verdienen",

  // FAQ
  "FAQ for creators": "FAQ für Creator",
  "Where can I get a tracked link, and can I link directly to a specific product?":
    "Wo finde ich einen Tracking-Link, und kann ich direkt auf ein bestimmtes Produkt verlinken?",
  "How long does it take for an order to be confirmed?":
    "Wie lange dauert es, bis eine Bestellung bestätigt wird?",
  "Where can I see my results and earnings?": "Wo kann ich meine Ergebnisse und Einnahmen sehen?",
  "How do payouts work, and is there a minimum payout amount?":
    "Wie funktionieren Auszahlungen, und gibt es einen Mindestauszahlungsbetrag?",
  "Which payment models are available for creators?":
    "Welche Vergütungsmodelle stehen Creatorn zur Verfügung?",
};

export default dict;
